import {
  service
} from '@/utils/request'
export default {
  //分页获取帖子列表
  getPostList: (params) => {
    return service({
      url: '/cloud/dvoice/v1/post/postListByPage',
      method: 'get',
      params: params
    })
  },
  //删除帖子
  deletPostApi: (path) => {
    return service({
      url: '/cloud/dvoice/v1/post/del' + path,
      method: 'get',
    })
  },
  //新增帖子
  addPostApi: (path,data) => {
    return service({
      url: '/cloud/dvoice/v1/post/add' + path,
      method: 'post',
      data:data
    })
  },
   //修改帖子信息
   editPostApi: (data) => {
    return service({
      url: '/cloud/dvoice/v1/post/modify',
      method: 'post',
      data:data
    })
  },
  //获取帖子详情 
  getPostDetail: (path) => {
    return service({
      url: '/cloud/dvoice/v1/post/model' + path,
      method: 'get',
    })
  },
  //获取帖子用户信息
  getCommentUserApi: (path) => {
    return service({
      url: '/cloud/uac/v1/users' + path,
      method: 'get',
    })
  },
  //获取帖子用户信息
  getComment: (path) => {
    return service({
      url: '/cloud/dvoice/v1/post/comment/order/like' + path,
      method: 'get',
    })
  },
  //回复评论
  addCommentApi: (data) => {
    return service({
      url: '/cloud/dvoice/v1/post/comment/commentaddRely',
      method: 'post',
      data: data
    })
  },
  //删除一级评论
  deleteFirstComment: (path) => {
    return service({
        url: '/cloud/dvoice/v1/post/comment/first/remove' + path,
        method: 'get',
      })
  },
  //删除二级评论
  deleteSecondComment: (path) => {
    return service({
        url: '/cloud/dvoice/v1/post/comment/second/remove' + path,
        method: 'get',
      })
  },
  // 通过审核
  audit(data) {
    return service({
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        transformRequest : [function (data) {
            let newData = ''
            for (let k in data) {
              newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&'
            }
            return newData
        }],
        url: '/cloud/dvoice/v1/post/changeaudit',
        method: 'post',
        data: data
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/contentManage/postManage.js